module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAEdJREFUeNpiXLJkyREGBgZrBtzgCBMBBSBgw4QuEh0djaGKiYEIwILNBBh76dKlqIpgAiAFMDZJ1mEoQjcFpugoAYOOAgQYANuEEcZXHHJKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/more.png
// module id = sy+7
// module chunks = 1